module.exports = __webpack_public_path__ + "static/media/notification-03.99cd96e1.m4a";